import { connect } from 'react-redux';
import { Table } from 'react-bootstrap';
import React, { useEffect } from 'react';
import { fetchEarningSummaryStart } from '../../../store/actions/WalletAction';

export const statsSummaryColors = ['purple', 'green', 'orange', 'brown', 'yellow', 'dark-brown'];

const EarningStats = (props) => {
  const { earningSummary } = props;

  const grossReducer = (previousValue, currentValue) => previousValue + currentValue.gross_amount;
  const netReducer = (previousValue, currentValue) => previousValue + currentValue.net_amount;

  useEffect(() => {
    props.dispatch(fetchEarningSummaryStart());
  }, []);
  return (
    <div className='security statement'>
      <div className='trans-table-sec'>
        <div className='trans-table'>
          <Table bordered={false} borderless={true} responsive='true'>
            <thead>
              <tr>
                <th>DESCRIPTION</th>
                <th className='text-center'>AMOUNT</th>
                <th className='text-center'>NET</th>
              </tr>
            </thead>
            <tbody>
              {earningSummary.data.stats.map((stats, index) => {
                return (
                  <tr>
                    <td className={`text-left d-flex flex-row align-items-center`}>
                      {' '}
                      <span
                        className={`d-flex dot bg-color-${statsSummaryColors[index]}`}
                      ></span>{' '}
                      {stats.usage_type}
                    </td>
                    <td className='text-center'>{stats.gross_amount_formatted} </td>
                    <td className='text-center'> {stats.net_amount_formatted} </td>
                  </tr>
                );
              })}
              <tr style={{ fontWeight: 700 }}>
                <td>TOTAL</td>
                <td className='text-center'>
                  <span>Gross:</span> {earningSummary.data.total.gross_amount}
                </td>
                <td className='text-center'>
                  <span>NET: </span> {earningSummary.data.total.net_amount}{' '}
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

const mapStateToPros = (state) => ({
  userData: state.users,
  earningSummary: state.wallet.earningSummary,
});

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(EarningStats);
